<footer class="footer">
  <div class="container">
    <div class="row">

      <div class="col-md-8 margin-bottom">
        <span>{{NAME}}</span>
        <br>
        <span>{{ADDRESS}}</span>
        <br>
        <span>{{PHONE}}</span>
        <br>
        <span>{{EMAIL}}</span>
      </div>
      <div class="col-md-3 main-color">v-1.20220406</div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center small">© {{NAME}} 2018 |
        <a href="https://www.hsfda.com/aviso-legal/" target="_blank">{{ 'LEGAL_NOTICE' |
          translate }}</a>
        |
        <a href="https://www.hsfda.com/politica-de-privacidad/" target="_blank">{{
          'PRIVACY_POLICY' | translate }}</a>
      </div>
    </div>
  </div>
</footer>